module.exports = __webpack_public_path__ + "img/cipa-logo.a5d4a3ef.svg";